// extracted by mini-css-extract-plugin
module.exports = {"slide":"style-module--slide--2MTHE"};